/**
 * v0.16c.8 (D-439): a sentence of the public site that waits for legal review, said only here. Both languages are on
 * its one line: to change the words, edit that line; to take the sentence off the site, make it `null` and the page
 * leaves the line out. Nothing else holds these words (the browser test reads them from this file).
 */
export interface ReviewedSentence {
  tr: string;
  en: string;
}

/** Under "Sizi anlar, hızlandırır, hatırlar." on the landing page (B2cTanitim3) */
export const DATA_STAYS_SENTENCE: ReviewedSentence | null = { tr: 'Oppy bütün bunları dışarıya bağımlı olmadan, verileriniz, bilgileriniz yurtdışına gitmeden yapar.', en: 'Oppy does all of this without depending on outside services, and without your data and information leaving the country.' };

/** The sentence in the page's language, or null when it is taken off the site */
export function reviewedSentence(sentence: ReviewedSentence | null, language: string): string | null {
  if (!sentence) return null;
  return language.startsWith('en') ? sentence.en : sentence.tr;
}
